module.exports = "/_next/static/images/e0c1fd93fc2cd13c7955fb2a99de1d41-savingsbanner-md-1-5x.jpg";